class MainQuantityAdjust extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="number"]');
    this.minusBtn = this.querySelector('.qty-minus');
    this.plusBtn = this.querySelector('.qty-plus');
    this.min = parseInt(this.input.getAttribute('min')) || 1;
    this.max = parseInt(this.input.getAttribute('max')) || null;
    this.debounceDelay = 300;
    this.isDebouncing = false;
  }

  connectedCallback() {
    this.render();
    this.bindEvents();
  }

  render() {
    this.classList.add('quantity-wrapper');
  }

  debounceClick(callback) {
    if (this.isDebouncing) return;

    this.isDebouncing = true;
    this.minusBtn.disabled = true;
    this.plusBtn.disabled = true;

    callback();

    setTimeout(() => {
      this.isDebouncing = false;
      this.minusBtn.disabled = false;
      this.plusBtn.disabled = false;
    }, this.debounceDelay);
  }

  bindEvents() {
    this.minusBtn.addEventListener('click', () => {
      this.debounceClick(() => {
        let current = parseInt(this.input.value) || this.min;
        if (current > this.min) {
          this.input.value = current - 1;
          this.input.dispatchEvent(
            new Event('product-quantity:adjusted', { bubbles: true })
          );
        }
      });
    });

    this.plusBtn.addEventListener('click', () => {
      this.debounceClick(() => {
        let current = parseInt(this.input.value) || this.min;
        if (!this.max || current < this.max) {
          this.input.value = current + 1;
          this.input.dispatchEvent(
            new Event('product-quantity:adjusted', { bubbles: true })
          );
        }
      });
    });
  }
}

if (!customElements.get('main-quantity-adjust')) {
  customElements.define('main-quantity-adjust', MainQuantityAdjust);
}
